export enum CountryCode {
    ESTONIA = '233',
    FINLAND = '246'
}
